<mat-nav-list>

  <ng-container *ngFor="let itemsMenuPri of menuUsers">

    <ng-container *ngIf="!itemsMenuPri.subMenu">
      <a (click)="goToOpt(itemsMenuPri.url)"  mat-list-item>
        <span class="material-icons">{{itemsMenuPri.icon}}</span>
        <span>{{itemsMenuPri.title}}</span>
      </a>
    </ng-container>

    <ng-container *ngIf="itemsMenuPri.subMenu">
      <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="material-icons">{{itemsMenuPri.icon}}</span>
              <span>{{itemsMenuPri.title}}</span>
            </mat-panel-title>

          </mat-expansion-panel-header>

          <ng-container *ngFor="let itemsSubMenuPri of itemsMenuPri.subMenu">
            <a (click)="goToOpt(itemsSubMenuPri.url)" mat-list-item>
              <span class="material-icons">{{itemsSubMenuPri.icon}}</span>
              <span>{{itemsSubMenuPri.title}}</span>
            </a>
          </ng-container>

        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

  </ng-container>

  <a (click)="endSession()" mat-list-item>
    <span class="material-icons">logout</span>
    <span>Cerrar sesión</span>
  </a>

</mat-nav-list>
